import { ActionTypes } from "../constants";

export default function riskProfiler(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_RISK_PROFILER:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}